import React, { useState, useEffect } from 'react'
import ModalFormUI from '../../../widgets/form/ModalFormUI'

const BulkDraftProceedModalUI = ({
  // Modes
  context, successMsg, errorList, setErrorList, submitted,
  uploadMode,
  // Event Handlers
  onSubmit, onCancelClick,
  // File input
  fileInput
}) => {
  const [selectedFile, setSelectedFile] = useState(null);

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    setSelectedFile(file);
  };

  return (
    <ModalFormUI
      context={context}
      titleLabel='Upload Draft Proceeds Excel File'
      buttonLabel="Upload"
      cancelLabel="Cancel"
      isOpen={uploadMode}
      onRequestClose={onCancelClick}
      successMsg={successMsg}
      errorList={errorList}
      setErrorList={setErrorList}
      onSubmit={onSubmit}
      busy={submitted}
    >

    <div className='g_m_bottom_50'>
      <label className='g_small g_muted' style={{ display: 'block', marginBottom: '10px' }}>
        Select Excel file (.xlsx)
      </label>
      <input 
        type='file' 
        ref={fileInput} 
        accept='.xlsx,.xls,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel'
        className='g_m_top_25'
        onChange={handleFileChange}
        style={{ display: 'block', width: '100%' }}
      />
      {selectedFile && (
        <div className='g_m_top_10 g_small'>
          Selected: {selectedFile.name}
        </div>
      )}
    </div>
    </ModalFormUI>
  );
};

export default BulkDraftProceedModalUI;
